import React from "react";
import { JOB_SEEKERS } from "../data/mock";
import Reveal from "../components/Reveal";
import { PageHero, SectionHead, NumberedRow, CTABand } from "../components/SharedUI";

const JobSeekers = () => {
  const d = JOB_SEEKERS;
  return (
    <div>
      <PageHero eyebrow={d.eyebrow} lines={d.titleLines} intro={d.intro} cta={d.cta} />

      {/* Journey */}
      <section className="bg-[var(--cream)] py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto px-6 md:px-8 grid lg:grid-cols-[0.8fr_1.2fr] gap-14 lg:gap-20">
          <div className="lg:sticky lg:top-32 self-start">
            <SectionHead eyebrow={d.journey.eyebrow} title={d.journey.title} />
          </div>
          <div>
            {d.journey.items.map((it, i) => (
              <NumberedRow key={it.num} {...it} delay={i * 80} />
            ))}
            <div className="border-t border-black/10" />
          </div>
        </div>
      </section>

      {/* Who we help */}
      <section className="grain bg-[#16233f] text-white py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto px-6 md:px-8">
          <Reveal>
            <div className="eyebrow mb-4">{d.whoWeHelp.eyebrow}</div>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-serif text-[38px] md:text-[52px] font-semibold mb-16">{d.whoWeHelp.title}</h2>
          </Reveal>
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-2">
              {d.whoWeHelp.items.map((it, i) => (
                <Reveal key={it.num} delay={i * 90}>
                  <div className="border-t border-white/15 py-7">
                    <div className="flex items-baseline gap-5">
                      <span className="font-serif text-3xl text-[var(--gold)]/70">{it.num}</span>
                      <div>
                        <h3 className="font-serif text-2xl font-semibold mb-2">{it.title}</h3>
                        <p className="text-white/60 text-sm leading-relaxed">{it.body}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal delay={150}>
              <div className="img-zoom rounded-sm overflow-hidden shadow-2xl">
                <img src={d.whoWeHelp.image} alt="Professionals in discussion" className="w-full h-[480px] object-cover" />
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <CTABand title={d.cta2.title} body={d.cta2.body} button={d.cta2.button} />
    </div>
  );
};

export default JobSeekers;
